<template>
	<el-dialog :title="codeType == 1?'条码补码':'删除条码'" :visible.sync="visible" :before-close='buCodeClose' width="1200px">
		<!-- 主功能区 -->
		<noscript>
			<iframe sandbox="allow-scripts allow-same-origin" ref="ifrm" id="ifrm" :src="srcData" width="0" height="0"></iframe>
		</noscript>
		<div class="codeView">
			<div class="codeNum">已选择条码数:{{codeNum}}</div>
			<template v-for="(item,index) in codes">
				<div class="codes" :class="item.is_check?'active':''" @click="handleSelectAllpCode(item)" :key="index">{{item.code}}
					使用次数{{item.totaltimes}}</div>
			</template>
		</div>
		<div class="footer">
			<el-input placeholder="请输入开始段" v-model="startInput" clearable maxlength="12" style="width: 200px;" size="small" />
			<div class="line">——</div>
			<el-input placeholder="请输入结束段" v-model="endInput" clearable maxlength="12" style="width: 200px;" size="small" />
			<el-button type="warning" style="margin: 0 30px 0 10px;" @click="handleSearchClick2" size="small">搜索</el-button>
			<el-input placeholder="请输入条码" v-model="codeInput" clearable maxlength="12" style="width: 200px;" size="small"/>
			<el-button type="warning" style="margin-left: 10px;" @click="handleSearchClick1" size="small">搜索</el-button>
			<el-button type="warning" @click="handleBuCodeClick" size="small" v-if="codeType == 1">条码补码</el-button>
			<el-button type="warning" @click="handleDeleteCodeClick" size="small" v-if="codeType == 2">删除条码</el-button>
		</div>
	</el-dialog>
</template>
<script>
	import {
		getGoodsCodeList
	} from '@/api/purchaseApi.js'
	import {
		// print
	} from '@/api/stockApi.js'
	import filter from '@/util/filter.js'
	import printJs from "../util/print.js"
	export default {
		props: {
			buCodeState: { //显示状态
				default: false
			},
			buCodeData: {
				default: []
			},
			id: {
				default: ''
			},
			codeType:{
				default:1
			}
		},
		data() {
			return {
				visible: true,
				codes: this.buCodeData,
				startInput: '',
				endInput: '',
				codeInput: '',
				srcData: '',
				codeNum: 0, //补码数量
			};
		},
		created() {
			this.codeNum = this.codes.length;
			let that = this;
			document.onkeydown = function() {
				var key = window.event.keyCode;
				if (key == 13) {
					that.handleSearchClick1()
				}
			}
			
		},
		methods: {
			//删除按钮
			handleDeleteCodeClick(){
				let printArr = [];
				let codeArr = JSON.parse(JSON.stringify(this.codes))
				for (let k = 0; k < codeArr.length; k++) {
					if (codeArr[k].is_check) {
						printArr[k] = Number(codeArr[k].code)
					} else {
						codeArr.splice(k, 1)
					}
				}
				
				if(printArr.length == 0){
					this.$message({
						message:'请选择条码',
						type:'warning'
					})
					return
				}
				console.log(printArr)
				let params = {
					procure_no:this.id,
					code:printArr
				}
				this.$http.post(process.env.VUE_APP_Url4 + 'api/Procure/DeleteGoodsCode',params).then(
					res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已删除'
							})
							this.$emit("closeOn", {
								type:false,
								data:'submit'
							});
						}
					})
			},
			//补码按钮
			handleBuCodeClick() {
				console.log(this.codes,"this.codes")
				let printArr = [];
				let codeArr = JSON.parse(JSON.stringify(this.codes))
				for (let k = 0; k < codeArr.length; k++) {
			  console.log(codeArr[k],"codeArr[k]");
					if (codeArr[k].is_check) {
						printArr[k] = {
							code: Number(codeArr[k].code),
							name: codeArr[k].name,
							sku: codeArr[k].totaltimes > 1 ? `${codeArr[k].sku}/${codeArr[k].totaltimes}次` : codeArr[k].sku,
							unit: codeArr[k].unit,
							price: codeArr[k].pprice,

						}
					} else {
						codeArr.splice(k, 1)
					}
				}

				let params = {
					bar_codes: printArr
				};
				printJs.printTicketBarCode(params.bar_codes).then(res=>{
					this.$store.commit("set_printUrl",res.msg)
				})
				// print(JSON.stringify(params)).then(data => {
				// 	if (data.url != "") {
				// 		this.srcData = `ChuLinPrint:${data.url}`;
				// 	}
				// });
			},
			//向父组件发射关闭弹框
			buCodeClose(done) {
				done()
				this.$emit("closeOn", {
					type:false,
					data:'close'
				});
			},
			handleSelectAllpCode(item) {
				item.is_check = !item.is_check;
				console.log(this.codes)
				let step = 0;
				for (let i = 0; i < this.codes.length; i++) {
					if (this.codes[i].is_check) {
						step++;
					}
				}
				this.codeNum = step;
			},
			//数组对象去重
			unique(arr) {
				const res = new Map();
				return arr.filter((arr) => !res.has(arr.code) && res.set(arr.code, 1))
			},
			//搜索按钮
			handleSearchClick2() {
				let params = {};
				if (filter.filterNumber(this.startInput)) {
					this.$message({
						message: '请输入数字',
						type: 'warning'
					})
					return
				}
				if (filter.filterNumber(this.endInput)) {
					this.$message({
						message: '请输入数字',
						type: 'warning'
					})
					return
				}
				if (this.startInput == '') {
					this.$message({
						message: '请输入条码开始段',
						type: 'warning'
					})
					return
				}
				if (this.endInput == '') {
					this.$message({
						message: '请输入条码结束段',
						type: 'warning'
					})
					return
				}
				params = {
					id: this.id,
					begin: filter.completionCode(this.startInput),
					end: filter.completionCode(this.endInput)
				}
				getGoodsCodeList(params).then((res) => {
					if (res.code == 0) {
						console.log(res)
						if(res.data.length != 0){
							let codeArr = [...this.codes];
							codeArr = codeArr.concat(res.data)
							// console.log(res.data,codeArr);
							codeArr = this.unique(codeArr)
							for(let i = 0;i<codeArr.length;i++){
								codeArr[i].is_check = true
							}
							console.log('最新',codeArr)
							this.codes = codeArr
						}
						else{
							this.$message({
								message:'请正确输入条码',
								type:'warning'
							})
						}
					}
				})
			},
			//搜索按钮
			handleSearchClick1() {
				let params = {};
				if (filter.filterNumber(this.codeInput)) {
					this.$message({
						message: '请输入数字',
						type: 'warning'
					})
					return
				}
				params = {
					id: this.id,
					key: filter.completionCode(this.codeInput)
				}
				getGoodsCodeList(params).then((res) => {
					if (res.code == 0) {
						console.log(res)
						if(res.data.length != 0){
							let codeArr = [...this.codes];
							codeArr = codeArr.concat(res.data)
							// console.log(res.data,codeArr);
							codeArr = this.unique(codeArr)
							for(let i = 0;i<codeArr.length;i++){
								codeArr[i].is_check = true
							}
							console.log('最新',codeArr)
							this.codes = codeArr
						}
						else{
							this.$message({
								message:'请正确输入条码段',
								type:'warning'
							})
						}
					}
				})

			}
		},
		watch: {
			// 监视状态发生改变
			buCodeState() {
				this.visible = this.buCodeState;
			},
		}
	};
</script>
<style lang="scss" scoped>
	.codeView {
		overflow: hidden;

		.codeNum {
			font-size: 16px;
			line-height: 32px;
			font-weight: bold;
		}

		.codes {
			padding: 0 5px;
			font-size: 14px;
			border: solid 1px #e9e9eb;
			background: #f4f4f5;
			color: #909399;
			line-height: 22px;
			float: left;
			margin-right: 14px;
			margin-bottom: 6px;
		}

		.active {
			background: #18A44C !important;
			color: #fff !important;
		}
	}

	.footer {
		border-top: solid 1px #ececec;
		padding-top: 20px;
		display: flex;
		justify-content: flex-end;
		align-items: center;

		.line {
			margin: 0 10px;
		}
	}
</style>
